module.exports = __webpack_public_path__ + "9779d9a1/img/trash-icon.ff8201c7.svg";